import React from 'react'

import ContactMethodContainer from 'src/containers/MyPage/ContactMethod'

const ContactMethodPage: React.FC = () => {
  return <ContactMethodContainer />
}

export const PATH = '/my-page/contact-method' as const
export default ContactMethodPage
